/// <amd-module name="Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorModule" />
import { IModule } from "redux-dynamic-modules";
import { IMarkdownEditorAwareState } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts";
import { markdownReducer } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorReducer";

export const MarkdownModule: IModule<IMarkdownEditorAwareState> = {
    id: "markdown-module",
    reducerMap: {
        markdownStateMap: markdownReducer
    }
};
